// extracted by mini-css-extract-plugin
module.exports = {"translate":"translations_translate__16Cmr"};